import React from 'react';
import { useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import { localAxios } from '../api';
import ScreenHeader from '../components/ScreenHeader';

export default function AccountPage() {
  const navigate = useNavigate();
  const { data } = useSWR('/api/me', localAxios);
  const canViewBilling = data?.data?.accessible_pages?.includes('billing');

  return (
    <div className="app-wide__container">
      <ScreenHeader message="Account" />
      <div className="app-wide__main home-page__main">
        {canViewBilling &&
          <button className="home-page__nav-btn" onClick={() => navigate('/billing')}>
            <span className="home-page__nav-title">Billing</span>
            <span className="home-page__nav-sub">View and manage billing information</span>
          </button>}
      </div>
    </div>
  );
}
